import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './scss/main.scss';
import 'leaflet/dist/leaflet.css';
import './registerServiceWorker';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ContactForm from '@/components/Contact/ContactForm.vue';

Vue.config.productionTip = false;

Vue.component('app-footer', Footer);
Vue.component('app-header', Header);
Vue.component('contact-form', ContactForm);

Vue.component('app-newsletter', (resolve) => {
  require(['@/components/Newsletter.vue'], resolve);
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
